export enum InitialAspectRatioOptionsEnum {
  '1:1' = 0,
  '10:3' = 1,
  '5:9' = 2,
  '3:2' = 3,
  '4:3' = 4,
  '16:9' = 5,
}
